import { render } from "./Index.vue?vue&type=template&id=33200132"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Devices/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33200132"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33200132', __exports__)) {
    api.reload('33200132', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=33200132", () => {
    api.rerender('33200132', render)
  })

}


export default __exports__